import { AgrLoginTypes, SignupSigninPolicy } from '@next/core-lib/environment';

import { Environment } from './environment.model';

export const environment: Environment = {
  APPLICATION_NAME: 'authorization-admin-site',
  API_BASE_URL: 'http://localhost:4200',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'http://localhost:4200',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.Employee,
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  APPLICATION_KEY: '*',
  APP_INSIGHTS_KEY: '',
  DEFAULT_LOCALE: 'en-US',
  LOCALES: ['en-US'],
  PRODUCTION: true,
  APIM_BASE_URL: 'http://localhost:4200/external',
};
